import React from "react";

const Step_four = ({ prevStep, nextStep, allColor, onFilterChange }) => {
  return (
    <>
      <section className="quizformsection Step_four">
        <div className="navigationdiv">
          <div className="row">
            <div className="col-12 text-center">
              <p className="formstepps">4/05</p>
            </div>
            <div className="col-12 text-center">
              <div className="formtitlediv">
                <h2 className="formtitle">Which colors do you like?</h2>
                <button className="backbtn" type="button" onClick={prevStep}>
                  <img
                    className="backicon"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/quick-quiz/backbtn.png"
                    }
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="productsdiv">
          <div className="row justify-content-center">
            {allColor?.map((data) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12  p-0 mb-3 "
                onClick={() => {
                  onFilterChange("colour", { id: data?.id, name: data.name });
                  nextStep();
                }}
              >
                <div className="productcard2">
                  <img
                    className="bgimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/quick-quiz/frame2.png"
                    }
                  />
                  <div className="oevrlaycont">
                    <div className="row justify-content-center">
                      <div className="col-6 my-auto">
                        <div
                          className="clrcircle"
                          style={{ backgroundColor: data.first_color }}
                        ></div>
                        {/* <img className='clrcircle' src={process.env.REACT_APP_IMAGE_URL + data?.image} /> */}
                        {/* <img className='clrcircle' style={{ backgroundColor: data?.first_color }} src={process.env.REACT_APP_IMAGE_URL + data?.image} /> */}
                      </div>
                      <div className="col-6 my-auto">
                        <p className="clrname">{data?.name}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* <div className='col-lg-3 col-md-4 col-sm-6 col-6  p-0 mb-3 '>
                            <div className='productcard2'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame2.png'} />
                                <div className='oevrlaycont'>
                                    <div className='row'>
                                        <div className='col-6 my-auto'>
                                            <img className='clrcircle' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/circle.png'} />
                                        </div>
                                        <div className='col-6 my-auto'>
                                            <p className='clrname'>Colors</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-4 col-sm-6 col-6  p-0 mb-3 '>
                            <div className='productcard2'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame2.png'} />
                                <div className='oevrlaycont'>
                                    <div className='row'>
                                        <div className='col-6 my-auto'>
                                            <img className='clrcircle' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/circle.png'} />
                                        </div>
                                        <div className='col-6 my-auto'>
                                            <p className='clrname'>Naturals</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-4 col-sm-6 col-6  p-0 mb-3 '>
                            <div className='productcard2'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame2.png'} />
                                <div className='oevrlaycont'>
                                    <div className='row'>
                                        <div className='col-6 my-auto'>
                                            <img className='clrcircle' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/circle.png'} />
                                        </div>
                                        <div className='col-6 my-auto'>
                                            <p className='clrname'>Black</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-4 col-sm-6 col-6  p-0 mb-3 '>
                            <div className='productcard2'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame2.png'} />
                                <div className='oevrlaycont'>
                                    <div className='row'>
                                        <div className='col-6 my-auto'>
                                            <img className='clrcircle' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/circle.png'} />
                                        </div>
                                        <div className='col-6 my-auto'>
                                            <p className='clrname'>Tortoises</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>

        <div className="nextbuttondiv">
          <button className="nextbtn" onClick={nextStep}>
            No preference
          </button>
        </div>
      </section>
    </>
  );
};

export default Step_four;
